import {
  Avatar, AvatarProps, ICON_CASH_CHECK,
} from '@doveit/bricks';
import React from 'react';

export type InvoiceAvatarProps = Pick<AvatarProps, 'size' | 'placeholder'>;

export const InvoiceAvatar: React.FC<InvoiceAvatarProps> = (props) => (
  <Avatar
    {...props}
    aria-label="Avatar pagamento"
    placeholder={ICON_CASH_CHECK}
  />
);

export default InvoiceAvatar;
